<template>
  <figure class="lightbox-trigger" @click="open = true">
    <img :src="src" :alt="alt" />
    <span class="lightbox-trigger__hint">Tap to expand</span>
  </figure>
  <Teleport to="body">
    <div v-if="open" class="lightbox-overlay" @click="open = false">
      <img :src="src" :alt="alt" class="lightbox-overlay__image" />
    </div>
  </Teleport>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
  src: { type: String, required: true },
  alt: { type: String, required: true },
})

const open = ref(false)
</script>

<style>
.lightbox-trigger {
  cursor: pointer;
  position: relative;
}

.lightbox-trigger img {
  transition: opacity 0.15s ease;
}

.lightbox-trigger:hover img {
  opacity: 0.85;
}

.lightbox-trigger__hint {
  position: absolute;
  bottom: 8px;
  right: 8px;
  font-size: 10px;
  color: var(--shell-text-muted, #65584b);
  background: var(--shell-surface-strong, #fffaf3);
  padding: 2px 8px;
  border-radius: 3px;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.lightbox-trigger:hover .lightbox-trigger__hint {
  opacity: 1;
}

/* Touch devices: always show hint since there is no hover */
@media (hover: none) {
  .lightbox-trigger__hint {
    opacity: 0.7;
  }
}

.lightbox-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(20, 16, 13, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: zoom-out;
  padding: 40px;
}

.lightbox-overlay__image {
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 4px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.4);
}
</style>
